import React, { useState } from "react";
import "./App.css";
import logo from "./founder_purity.png";
import ReactGA from "react-ga";
import { FaTwitter } from "react-icons/fa";

function App() {
  let prompts = [
    "Started a side hustle",
    "Went to an ivy league and won’t shut up about it",
    "Had crippling imposter syndrome",
    "Been rejected by Y-combinator",
    "Convinced you were going to be a unicorn",
    "Called yourself the CEO when it’s only you",
    "Pulled an all nighter for your startup",
    "Got rejected by an investor",
    "Cried because of your startup",
    "Name dropped someone you don’t actually know",
    "Had a Clubhouse phase",
    "'Hired' an unpaid intern",
    "Put someone on payroll",
    "Put 10 people on payroll",
    "Put 100 people on payroll",
    "Put your startup in your tinder bio",
    "Started a Slack workspace for your company",
    "Paid for Slack premium",
    "Made a pitch deck",
    "Said “ML”, “AI”, or “Blockchain” in a pitch",
    "Outsourced something for your startup",
    "Have seriously considered doing an NFT drop as a marketing strategy",
    "Been to a WeWork",
    "Gotten drunk at a networking event",
    "Moved a Monday meeting because you’re too hungover from the night before",
    "Had the urge to drop everything and start a b2b saas company",
    "Own 10+ pieces of swag from other startups",
    "Expense something for your startup that probably shouldn't be expensed",
    "Immediately encountered a bug when doing a live demo",
    "Fired an employee",
    "Made stickers for your startup",
    "Made merch for your startup",
    "Crashed on the couch of another founder",
    "Took a meeting while drunk or high",
    "Went into credit card debt for your startup",
    "Have a friend who can't stop talking about bitcoin",
    "Can't stop listeneing to low-fi",
    "Launched to product hunt",
    "Put everything on notion",
    "Gotten press coverage",
    "Quit your job for a startup",
    "Dropped out of college to pursue a startup",
    "Burned out",
    "Use your startup to help get you laid",
    "Missed a family event or birthday because of your startup",
    "Pushed something to prod without testing",
    "Had to fight over a name, trademark, or other IP",
    "Received a cease and desist",
    "Been sued",
    "Done something illegal for your startup",
    "Worked while high or drunk",
    "Microdosed to be more productive for your startup",
    "Posted a thread to Twitter",
    "Posted a “who should I meet” tweet",
    "'Building something new' in bio",
    "Following Elon Musk on Twitter",
    "Posted a Medium Article",
    "Started your own podcast",
    "Featured as a podcast guest",
    "Went viral on any platform and received >1Million impressions",
    "Lived in a Hacker House",
    "Lived at launch house",
    "30 under 30",
    "Made a meme about your startup on Figma",
    "Had 10+ zoom calls in a day",
    "Had a work meeting between the hours of 2am-4am",
    "Are obsessed with superhuman",
    "Read a Paul Graham article",
    "Got an offshore virtual assistant",
    "Been rejected by app store review process",
    "Your startup name is purposefully misspelled",
    "Identified as a digital nomad",
    "Shoehorned blockchain into your product",
    "Almost built in a drop in audio feature",
    "Attended a watch party for the social network",
    "Had a falling out with a cofounder",
    "Threw an unsuccessful company zoom social",
    "Incorporated a company",
    "Bought a domain for an idea you had less than 24 hours ago",
    "Pitched to a VC",
    "Know what a SAFE is",
    "Pivoted",
    "PMF",
    "Received any funding",
    "Raised a seed",
    "Closed a series A",
    "Closed a series B",
    "Closed a series C",
    "Reached a 10mil valuation",
    "Reached a 100mil valuation",
    "Reached a 1bil+ valuation",
    "Your startup failed :(",
    "Run two companies at the same time",
    "Been wined and dined by potential investors",
    "Been part of an accelerator / incubator",
    "Turn down an investment offer",
    "Received revenue",
    "Met a billionaire in person",
    "IPO’d",
    "Got a tattoo of your startup",
  ];
  var urlencode = require("urlencode");
  let [showScore, setShowScore] = useState(false);
  let [score, setScore] = useState(100);
  let selected = {};
  for (let i = 1; i <= 100; i += 1) {
    selected[i] = false;
  }

  ReactGA.initialize("UA-204217046-1");
  ReactGA.pageview("main");

  function logHandle() {
    ReactGA.event({
      category: "User",
      action: "handle",
    });
  }

  function logShare() {
    ReactGA.event({
      category: "User",
      action: "share",
    });
    let url =
      "https://twitter.com/intent/tweet?text=" +
      urlencode(
        `I scored ${score} on the founder purity test! Can you beat me?\n\n#founderpuritytest\nhttps://twitter.com/theJohnHerrick/status/1423351592644796416`
      );
    window.open(url, "_blank");
  }

  function getScore() {
    ReactGA.event({
      category: "User",
      action: "score",
    });
    let total = 0;
    for (let i = 1; i <= 100; i += 1) {
      if (!selected[i]) {
        total += 1;
      } else {
        ReactGA.event({
          category: "score",
          action: i,
        });
      }
      setScore(total);
      setShowScore(true);
    }
  }

  return (
    <div className="big">
      <div className="App">
        <div className="logoTop">
          <img src={logo} alt="logo"></img>
        </div>
        {!showScore && (
          <header className="App-header">
            <h3 className="disclaimer">
              Inspired by the Rice Purity Test, The Founder Purity test is a
              measure of how much founder experience you have.{" "}
            </h3>
            <h3 className="caution">
              Caution: This is not a bucket list. Completion of all items on
              this test will likely result in being memed by the internet.
            </h3>
            <h3 className="instructions">Click on every item you have done.</h3>
          </header>
        )}

        {!showScore && (
          <body>
            <div>
              <form className="theForm">
                {prompts.map((txt, idx) => {
                  return (
                    <Question
                      className="question2"
                      num={idx + 1}
                      text={txt}
                      selected={selected}
                    ></Question>
                  );
                })}
                <br></br>
                <button class="submitButton" onClick={getScore}>
                  Calculate my score
                </button>
              </form>
            </div>
          </body>
        )}
        {showScore && (
          <body>
            <div className="logoTop">
              <h1 className="scoreHeader">Your score:</h1>
              <h1 className="score">{score}</h1>
              <h3 className="disclaimer">
                The lower the score, the more experience you have
              </h3>
              <button class="share" onClick={logShare}>
                <FaTwitter class="twitter" /> Share
              </button>
            </div>
          </body>
        )}
        {!showScore && (
          <footer className="foot">
            <a
              href="https://twitter.com/theJohnHerrick"
              onClick={logHandle}
              className="foot"
            >
              @theJohnHerrick
            </a>
          </footer>
        )}
      </div>
    </div>
  );
}

function Question(props) {
  return (
    <label className="question">
      {props.num}.
      <input
        type="checkbox"
        onChange={() => {
          props.selected[props.num] = !props.selected[props.num];
          console.log(props.selected);
        }}
        className="questionBox"
        name="name"
      />
      {props.text}
      <br></br>
    </label>
  );
}

export default App;
